import { ActivityTypeAction, ActivityTypeState } from 'store/data/activityType';
import { domainUtility } from 'utility';

const initialState: ActivityTypeState = { allIds: [], byId: {} };

const activityTypeReducer = (
  state: ActivityTypeState = initialState,
  action: ActivityTypeAction,
): ActivityTypeState => {
  switch (action.type) {
    case 'data/activityType/ADD':
      return domainUtility.add(state, action.payload);
    case 'data/activityType/SET':
      return domainUtility.set(state, action.payload);
    case 'data/activityType/UPDATE':
      return domainUtility.update(state, action.payload);
    case 'data/activityType/REMOVE':
      return domainUtility.remove(state, action.payload);
    case 'data/activityType/SET_DOMAIN': {
      const { allIds, byId } = action.payload;
      return { allIds, byId };
    }
    default:
      return state;
  }
};

export default activityTypeReducer;
